module.exports = __webpack_public_path__ + "static/mascot-shopify-35c3462ec81b53bbaa4b7be5efd500cf.png";